import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Avatar,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Container
} from "@mui/material";
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'

import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Business as BusinessIcon,
  Apps as AppsIcon,
  LocationOn as LocationIcon,
  Person as PersonIcon
} from "@mui/icons-material";

const index = () => {
  const AppService = useAppServices();
  const [groupedData, setGroupedData] = useState({});
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAppName = (appId) => {
    const app = apps.find(app => app.app_id === appId);
    return app ? app.name : 'Unknown App';
  };

  const getData = async () => {
    try {
      const { response } = await AppService.superadmin_users.get({ toaster: false });

      const grouped = response.data.reduce((acc, curr) => {
        const key = `${curr.email}-${curr.phone}-${curr.name}`;
        if (!acc[key]) {
          acc[key] = {
            user: {
              name: curr.name,
              email: curr.email,
              phone: curr.phone,
              company_id: curr.company_id
            },
            installations: []
          };
        }
        acc[key].installations.push({
          location_id: curr.location_id,
          app_id: curr.app_id,
          type: curr.type,
          createdAt: new Date(curr.createdAt).toLocaleString()
        });
        return acc;
      }, {});


      console.log("grouped",grouped)

      setGroupedData(grouped);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getApps = async () => {
    try {
      const { response } = await AppService.app.app_names({ toaster: false });
      setApps(response.data);
    } catch (error) {
      console.error("Error fetching apps:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([getData(), getApps()]);
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }



  const filtered_groups = Object.values(groupedData)?.map((userData) => userData?.installations?.filter((install)=> install.app_id === "683efd5ea78c77efc1d8fe6e"))

console.log("filtered_groups",filtered_groups)


  return (
    <DashboardLayout>

      <Container maxWidth="xl">
        <Box sx={{ p: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
            User Installations
          </Typography>

          <Grid container spacing={3}>
            {
                Object.values(groupedData)
  .map((userData) => ({
    ...userData,
    installations: userData?.installations?.filter(
      (install) => install?.app_id === "683efd5ea78c77efc1d8fe6e"
    ),
  }))
  .filter((userData) => userData?.installations?.length > 0)
  .map((userData, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card sx={{ height: '100%', boxShadow: 3 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: 'primary.main' }}>
                        <PersonIcon />
                      </Avatar>
                    }
                    title={
                      <Typography variant="h6" component="div">
                        {userData.user.name}
                      </Typography>
                    }
                    subheader={
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, flexWrap: 'wrap' }}>
                        <EmailIcon fontSize="small" sx={{ mr: 1 }} />
                        <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
                          {userData.user.email}
                        </Typography>
                        <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
                        <Typography variant="body2" color="text.secondary">
                          {userData.user.phone}
                        </Typography>
                      </Box>
                    }
                  />

                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <BusinessIcon color="action" sx={{ mr: 1 }} />
                      <Typography variant="body2">
                        Company ID: {userData.user.company_id}
                      </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                      <AppsIcon sx={{ mr: 1 }} /> Installations ({userData.installations.length})
                    </Typography>

                    <Grid container spacing={2}>
                      {userData.installations.map((install, i) => (
                        <Grid item xs={12} key={i}>
                          <Paper elevation={2} sx={{ p: 2 }}>
                            <List dense>
                              <ListItem>
                                <ListItemText
                                  primary="App Name"
                                  secondary={
                                    <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'medium' }}>
                                      {/* {getAppName(install.app_id)} */}
                                      All The Apps AI
                                    </Typography>
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primary="Location ID"
                                  secondary={
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <LocationIcon color="primary" sx={{ mr: 1, fontSize: '16px' }} />
                                      {install.location_id}
                                    </Box>
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primary="App ID"
                                  secondary={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Chip
                                        label={install.app_id}
                                        size="small"
                                        icon={<AppsIcon fontSize="small" />}
                                        variant="outlined"
                                      />
                                      <Chip
                                        label={install.type}
                                        color="primary"
                                        size="small"
                                      />
                                    </Box>
                                  }
                                />
                              </ListItem>
                              <ListItem>
                                <ListItemText
                                  primary="Installed On"
                                  secondary={install.createdAt}
                                />
                              </ListItem>
                            </List>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </DashboardLayout>
  );
};

export default index;